import { GetObjectCommand, S3Client } from '@aws-sdk/client-s3'
import PapaParse from 'papaparse'

import { APP_CONFIG, CONFIGS_BY_ENVIRONMENT, STAGE } from 'src/config.app'
import { TableColumn, TableDataFormat } from 'src/pages/scoring-test-ui/TableDataFormat'
import { getHookCredentials, REGION } from 'src/services/aws/credentials'
import { multipartUpload } from 'src/services/aws/s3'

export interface CSVParseResult {
    data: []
    errors: []
    meta: { [key: string]: unknown }
}

/** istanbul ignore next */
export const getHookS3Client = async (stage?: STAGE) => {
    return new S3Client({
        region: REGION,
        credentials: await getHookCredentials(stage),
    })
}

export const getBucket = (stage?: STAGE): string =>
    stage
        ? CONFIGS_BY_ENVIRONMENT[stage].hookConfig.s3InputBucketName
        : APP_CONFIG.hookConfig.s3InputBucketName

/**
 * upload file to S3 using the given path
 */
export async function uploadFileToS3(localFile: File, path: string, stage?: STAGE) {
    const client = await getHookS3Client(stage)
    return await multipartUpload(client, localFile, {
        Bucket: getBucket(stage),
        Key: path,
    })
}

/**
 * get file from S3 using the given path
 */
export async function downloadFileFromS3(path: string, stage?: STAGE) {
    const client = await getHookS3Client(stage)
    return await client.send(
        new GetObjectCommand({
            Bucket: getBucket(stage),
            Key: path,
        })
    )
}

/**
 * parse response given by S3 GET call
 */
export async function parseS3GetResponse(response: string, outputFileName: string) {
    const localFileTableList = new Map<string, TableDataFormat>()
    await new Promise((resolve, reject) =>
        PapaParse.parse(response, {
            skipEmptyLines: true,
            header: true,
            complete: resolve,
            error: reject,
        })
    )
        .then((result) => {
            const resultObj = result as CSVParseResult
            const columns: TableColumn[] = (resultObj.meta['fields'] as string[]).map(function (
                x: string
            ) {
                return {
                    header: x,
                    accessor: x,
                    sortId: x,
                }
            })

            localFileTableList.set(outputFileName, {
                columns: columns,
                data: resultObj.data,
            })
        })
        .catch((err) => {
            console.error(err)
            throw new Error(
                `Something went wrong while parsing your file: ${(err as Error).message}`
            )
        })
    return localFileTableList
}
